import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { OrderState } from './types';
import { RootState } from '../types';
import { getDefaultState } from '../utils';

export const state: OrderState = {
  basket: { ...getDefaultState() },
  order: { ...getDefaultState() },
  orderLater: { ...getDefaultState() },
};

const namespaced = true;

export const order: Module<OrderState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
